import * as Yup from "yup";

export const AddOrChangeRecipientSchema = Yup.object().shape({
  email: Yup.string()
    .email("recipient-validation.valid-email")
    .required("recipient-validation.required-email"),
});
